import React from "react";
import { FaFacebookF, FaTelegramPlane } from "react-icons/fa";
import logo from "../../assets/logo.png";

const Footer = () => {
  return (
    <footer className="xl:container xl:mx-auto px-6 py-8 text-gray-400 bg-[#191b24]">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 2xl:gap-40 border-t border-yellow-200/10 pt-10">
        {/* Cột Trái */}
        <div className="md:col-span-5 lg:col-span-5 space-y-5">
          <img src={logo} alt="Logo MePhim" className="w-auto h-10 mt-2 mb-4" />

          <p className="text-xs lg:text-md leading-relaxed text-gray-300">
            MePhim - Xem phim trực tuyến miễn phí, chất lượng HD đến 4k, cập
            nhật nhanh nhất. Trải nghiệm mượt mà, không quảng cáo khi xem, đa
            nền tảng.
          </p>
          <div className="pt-2">
            <p className="font-semibold text-white mb-3 uppercase text-xs lg:text-base">
              Liên Hệ Thông Tin
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                aria-label="Facebook"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-gray-700 text-gray-300 hover:bg-yellow-400 hover:text-white transition-all duration-300 ease-in-out transform hover:scale-102"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF size={18} />
              </a>
              <a
                href="#"
                aria-label="Telegram"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-gray-700 text-gray-300 hover:bg-yellow-400 hover:text-white transition-all duration-300 ease-in-out transform hover:scale-102"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTelegramPlane size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-6 grid grid-cols-3 gap-6 col-span-full sm:grid-cols-3 lg:col-span-6 space-x-2">
          <div>
            <h1 className="text-xs lg:text-base font-semibold text-white mb-5 uppercase tracking-wider">
              Về chúng tôi
            </h1>
            <ul className="space-y-3 text-xs lg:text-sm">
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Giới thiệu
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Chính sách riêng tư
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Điều khoản sử dụng
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Liên hệ với chúng tôi
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Sơ đồ trang web
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-xs lg:text-base font-semibold text-white mb-5 uppercase tracking-wider">
              Thể loại
            </h3>
            <ul className="space-y-3 text-xs lg:text-sm">
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Chính Kịch
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Hành Động
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Hài Hước
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Tâm Lý
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Tình Cảm
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs lg:text-base font-semibold text-white mb-5 uppercase tracking-wider">
              Quốc gia
            </h3>
            <ul className="space-y-3 text-xs lg:text-sm">
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Việt Nam
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Âu Mỹ
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Trung Quốc
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Nhật Bản
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-white transition-colors duration-200"
                >
                  Hàn Quốc
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-yellow-200/10 mt-10 pt-6 text-center">
        <p className="text-sm text-gray-400">
          Made By <span className="text-white">Meo Meo</span>
        </p>
        <p className="text-xs text-gray-300 mt-1">
          PPhim © 2025 All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
